module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('ToastMessage'), _vm._v(" "), _c('website', {
    ref: "website"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('Galleria', {
    staticStyle: {
      "max-width": "100%",
      "width": "90%"
    },
    attrs: {
      "value": this.images,
      "responsiveOptions": _vm.responsiveOptions2,
      "thumbnailsPosition": "right",
      "numVisible": 4,
      "showIndicators": false,
      "showItemNavigators": true,
      "showItemNavigatorsOnHover": true
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(slotProps) {
        return [_c('img', {
          staticStyle: {
            "width": "98%",
            "display": "block"
          },
          attrs: {
            "src": slotProps.item.name,
            "alt": slotProps.item.name
          }
        })]
      }
    }, (this.images.length > 1) ? {
      key: "thumbnail",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "p-grid p-nogutter p-justify-center"
        }, [_c('img', {
          staticStyle: {
            "display": "block",
            "width": "100%"
          },
          attrs: {
            "src": slotProps.item.name,
            "alt": slotProps.item.name
          }
        })])]
      }
    } : null], null, true)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "product-single__title"
  }, [_vm._v("\n          " + _vm._s(this.itemName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "prInfoRow"
  }), _vm._v(" "), _c('p', {
    staticClass: "product-single__price product-single__price-product-template"
  }, [_c('span', {
    staticClass: "product-price__price product-price__price-product-template"
  }, [_c('span', {
    staticClass: "money bacurr-money"
  }, [_c('b', [_vm._v("Nrs. " + _vm._s(this.sellingPrice))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("SIZE: "), _c('b', [_vm._v(_vm._s(this.selectedSize))])]), _vm._v(" "), _c('SelectButton', {
    attrs: {
      "options": _vm.options
    },
    model: {
      value: (_vm.selectedSize),
      callback: function($$v) {
        _vm.selectedSize = $$v
      },
      expression: "selectedSize"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('Button', {
    staticClass: "p-button-outlined ",
    attrs: {
      "label": "COTTON BLEND"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-mt-2 infolinks"
  }, [_vm._v("SIZE GUIDE:")]), _vm._v(" "), _c('div', {
    staticClass: "p-grid"
  }, [_c('div', {
    staticClass: "p-col-12 p-md-6 p-lg-3"
  }, [_c('Button', {
    staticClass: "p-button-secondary p-button-text",
    attrs: {
      "icon": "pi pi-minus"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deductQty.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('InputText', {
    staticClass: "p-col-6",
    model: {
      value: (_vm.qty),
      callback: function($$v) {
        _vm.qty = $$v
      },
      expression: "qty"
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-secondary p-button-text",
    attrs: {
      "icon": "pi pi-plus"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addQty.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-9 p-lg-9",
    staticStyle: {
      "margin-left": "-.5em"
    }
  }, [_c('Button', {
    staticClass: "p-button-warning p-lg-12",
    attrs: {
      "label": "ADD TO CART"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addToCart.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-6 p-lg-12"
  }, [_c('Button', {
    staticClass: "p-button-info p-lg-12",
    attrs: {
      "label": "BUY IT NOW"
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "tabs-listing wow fadeIn",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeIn"
    }
  }, [_c('TabView', [_c('TabPanel', {
    staticClass: "active",
    staticStyle: {
      "color": "#141415",
      "border-color": "#1b1c1d"
    },
    attrs: {
      "header": "PRODUCT DETAILS "
    }
  }, [_c('p', {
    staticClass: "tab-content",
    staticStyle: {
      "color": "#141415",
      "border-color": "#1b1c1d"
    }
  }, [_vm._v(_vm._s(this.description))])]), _vm._v(" "), _c('TabPanel', {
    attrs: {
      "header": "PRODUCT REVIEW"
    }
  }, [_c('p', [_vm._v("Very High Quality Loved It")])]), _vm._v(" "), _c('TabPanel', {
    attrs: {
      "header": "EXCHANGE & CANCELLATIONS"
    }
  }, [_c('h5', [_vm._v("How do I Cancel or Exchange?")]), _vm._v(" "), _c('p', [_vm._v("\n            Drop an Email on talk.lilpicks@gmail.com or whatsApp on 9911437000\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            What items are non-exchangeable?\n            You can exchange your items within 15 days of receipt of your shipment.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            They must be in original condition\n          ")]), _vm._v("\n          Must be unwashed and unworn\n          "), _c('p'), _vm._v("\n          In the original packaging\n          "), _c('p'), _vm._v("\n          Free gifts or promotional items are non-exchangeable !\n          "), _c('p'), _vm._v(" "), _c('h5', [_vm._v("\n            Are there any charges for exchange?\n          ")]), _vm._v("\n\n          There are no charges for exchange.\n          "), _c('p'), _vm._v(" "), _c('h5', [_vm._v("\n            How soon will I get my exchange product?\n          ")]), _vm._v("\n          Once your return is received and inspected, we will send you an email to notify you that we have received\n          your returned item. We will also notify you of the approval or rejection of your exchange. If you are\n          approved, then your exchange\n          "), _c('p'), _vm._v("\n          will be processed, and mention your exchange items on mail or whatsApp. We will dispatch your product within\n          2-3 days.\n        ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('Carousel', {
    attrs: {
      "value": _vm.displayItemList,
      "numVisible": 4,
      "numScroll": 1,
      "responsiveOptions": _vm.responsiveOptions,
      "circular": true,
      "autoplayInterval": 3000
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(slotProps) {
        return [_c('div', {
          staticStyle: {
            "border-bottom": "0px solid #c8c8c8"
          }
        }, [_c('div', {
          staticClass: "productList"
        }, [_c('div', {
          staticClass: "grid__item small--one-half medium--one-third large-up--one-quarter"
        }, [_c('div', {
          staticClass: "grid-view-item style1 wow fadeIn"
        }, [_c('div', {
          staticClass: "grid-view_image"
        }, [_c('a', {
          attrs: {
            "href": ""
          }
        }, [_c('img', {
          staticStyle: {
            "height": "365px",
            "width": "75%"
          },
          attrs: {
            "src": slotProps.data.singleImageUrl,
            "alt": slotProps.data.name
          },
          on: {
            "click": function($event) {
              return _vm.viewProductDetailsPage(slotProps.data)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "grid-view-item__title",
          staticStyle: {
            "margin": "2% 0%"
          }
        }, [_vm._v(_vm._s(slotProps.data.name))]), _vm._v(" "), _c('span', {
          staticClass: "product-price__price"
        }, [_vm._v("Nrs." + _vm._s(slotProps.data.salesRate))]), _vm._v(" "), _c('div', {
          staticClass: "product-description"
        }, [_vm._v(_vm._s(slotProps.data.description))])])])])])])]
      }
    }])
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('DataView', {
    staticClass: "grid grid--uniform grid-products grid--view-items",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.displayItemList,
      "paginator": true,
      "rows": 4,
      "layout": _vm.layout
    },
    scopedSlots: _vm._u([{
      key: "grid",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "p-col-12 p-md-3",
          staticStyle: {
            "border-bottom": "0px solid #c8c8c8"
          }
        }, [_c('div', {
          staticClass: "productList"
        }, [_c('div', {
          staticClass: "grid__item small--one-half medium--one-third large-up--one-quarter"
        }, [_c('div', {
          staticClass: "grid-view-item style1 wow fadeIn"
        }, [_c('div', {
          staticClass: "grid-view_image"
        }, [_c('a', {
          attrs: {
            "href": ""
          }
        }, [_c('img', {
          staticStyle: {
            "height": "365px",
            "width": "75%"
          },
          attrs: {
            "src": slotProps.data.singleImageUrl,
            "alt": slotProps.data.name
          },
          on: {
            "click": function($event) {
              return _vm.viewProductDetailsPage(slotProps.data)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "grid-view-item__title",
          staticStyle: {
            "margin": "2% 0%"
          }
        }, [_vm._v(_vm._s(slotProps.data.name))]), _vm._v(" "), _c('span', {
          staticClass: "product-price__price"
        }, [_vm._v("Nrs." + _vm._s(slotProps.data.salesRate))]), _vm._v(" "), _c('div', {
          staticClass: "product-description"
        }, [_vm._v(_vm._s(slotProps.data.description))])])])])])])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('footerWebsite', {
    ref: "footerWebsite"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "slVariant p-mt-2"
  }, [_vm._v("FABRIC: "), _c('b', [_vm._v("COTTON BLEND")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-grid p-mt-5"
  }, [_c('div', {
    staticClass: "p-col-fixed",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('span', {
    staticClass: "pi pi-heart",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("View Wishlist")])]), _vm._v(" "), _c('div', {
    staticClass: "p-col"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-col"
  }, [_c('span', {
    staticClass: "pi pi-facebook p-ml-2",
    staticStyle: {
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Share")]), _vm._v(" "), _c('span', {
    staticClass: "pi pi-twitter p-ml-2",
    staticStyle: {
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tweet")]), _vm._v(" "), _c('span', {
    staticClass: "pi pi-envelope p-ml-2",
    staticStyle: {
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Email")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-col p-mt-5"
  }, [_c('span', {
    staticClass: "pi pi-shopping-cart",
    staticStyle: {
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "p-ml-2"
  }, [_vm._v("Your order is eligible for FREE Delivery.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-col"
  }, [_c('span', {
    staticClass: "pi pi-clock",
    staticStyle: {
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "p-ml-2"
  }, [_vm._v("Estimated delivery between Wed. Sep 29 and Tue. Oct 5.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-col "
  }, [_c('span', {
    staticClass: "pi pi-users ",
    staticStyle: {
      "font-size": "16px",
      "color": "red"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "p-ml-2"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("43")]), _vm._v(" Other parents looking for this product")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header text-center wow fadeIn",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeIn"
    }
  }, [_c('h2', {
    staticClass: "section-header__title text-center h2"
  }, [_vm._v("RELATED PRODUCTS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header text-center wow fadeIn",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeIn"
    }
  }, [_c('h2', {
    staticClass: "section-header__title text-center h2"
  }, [_vm._v("RECENTLY VIEWED PRODUCT")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb27a21c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ecommerce/productDetails.vue
// module id = 2432
// module chunks = 0